import styled from 'styled-components';

import ImageIdBackGuide from 'images/pictographs/id-back-guide.svg';

const Positioner = styled('div')`
  position: relative;
  right: 0;
  top: 100%;
  bottom: 100%;
`;

export default function IdBackGuide() {
  return (
    <Positioner data-test='id-back__guide'>
      <ImageIdBackGuide />
    </Positioner>
  );
}
